import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { WalletRoutingModule } from './wallet-routing.module'
import { SpWalletComponent } from './pages/sp-wallet/sp-wallet.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { WalletListComponent } from './pages/wallet-list/wallet-list.component'
import { WalletTableComponent } from './components/wallet-table/wallet-table.component'
import { WalletFilterComponent } from './components/wallet-filter/wallet-filter.component'
import { WalletHistoryListComponent } from './pages/wallet-history-list/wallet-history-list.component'
import { SpWalletFilterComponent } from './components/sp-wallet-filter/sp-wallet-filter.component'
import { AddSubtractFundPopupComponent } from './components/add-subtract-fund-popup/add-subtract-fund-popup.component'
import { FinancialListComponent } from './pages/financial-list/financial-list.component'
import { FinancePaymentMethodFilterComponent } from './components/finance-payment-method-filter/finance-payment-method-filter.component'
import { FinancialTableComponent } from './components/financial-table/financial-table.component'
import { FinancialFilterComponent } from './components/financial-filter/financial-filter.component'
import { PayoutModule } from '../payout/payout.module'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import {
	MAT_MOMENT_DATE_ADAPTER_OPTIONS,
	MatMomentDateModule,
} from '@angular/material-moment-adapter'
import { MatDatepickerModule } from '@angular/material/datepicker'

@NgModule({
	declarations: [
		SpWalletComponent,
		WalletHistoryListComponent,
		SpWalletFilterComponent,
		AddSubtractFundPopupComponent,
		SpWalletComponent,
		WalletListComponent,
		WalletTableComponent,
		WalletFilterComponent,
		FinancialListComponent,
		FinancePaymentMethodFilterComponent,
		FinancialTableComponent,
		FinancialFilterComponent,
	],
	imports: [
		CommonModule,
		SharedModule,
		PayoutModule,
		WalletRoutingModule,
		MatDatepickerModule,
		MatMomentDateModule,
	],

	exports: [WalletHistoryListComponent],
	providers: [
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
		{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
	],
})
export class WalletModule {}
